/* Msofas help centre — search, suggestions, tabs, ordering guide, checklist, feedback, print, back-to-top.
   Loaded only on help pages (snippets/help-head.liquid). Search logic ported from the approved prototype (app.js find/mark).
   Plan: docs/superpowers/plans/2026-10-20-help-centre.md. Tests: scripts/help/search.test.mjs */
(function () {
  var SYN = { refund: 'return', refunds: 'return', shipping: 'delivery', colour: 'fabric', colors: 'fabric', payment: 'pay', installment: 'finance', instalments: 'finance', repair: 'warranty', broken: 'damage', swatches: 'samples', tracking: 'order' };
  var STOP = ['a', 'an', 'the', 'i', 'my', 'me', 'is', 'are', 'do', 'does', 'can', 'how', 'what', "what's", 'when', 'where', 'why', 'to', 'of', 'for', 'on', 'in', 'it', 'and', 'or', 'you', 'your', 'with'];
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var reEsc = function (x) { return x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };

  function terms(q) {
    var all = String(q || '').replace(/[’‘]/g, "'").toLowerCase().trim().split(/\s+/).filter(Boolean);
    if (all.join('').length < 2) return [];
    var kept = all.filter(function (t) { return STOP.indexOf(t) < 0; });
    return kept.length ? kept : all;
  }
  function find(index, q) {
    var ts = terms(q);
    if (!ts.length) return [];
    var groups = ts.map(function (t) { return SYN[t] ? [t, SYN[t]] : [t]; });
    return index.map(function (e) {
      var title = (e.t || '').replace(/[’‘]/g, "'").toLowerCase();
      var full = [e.t, e.s, e.b, e.k, e.c].join(' ').replace(/[’‘]/g, "'").toLowerCase();
      var score = 0, hits = 0;
      groups.forEach(function (g) {
        if (g.some(function (t) { return title.indexOf(t) >= 0; })) { score += 4; hits++; }
        else if (g.some(function (t) { return full.indexOf(t) >= 0; })) { score += 1; hits++; }
      });
      return { e: e, score: score, hits: hits };
    }).filter(function (x) { return x.hits === groups.length; })
      .sort(function (a, b) { return b.score - a.score; })
      .map(function (x) { return x.e; });
  }
  // match on the raw text, escape each piece afterwards: a term can never land inside an HTML entity
  function mark(text, q) {
    var raw = String(text == null ? '' : text);
    var ts = [];
    terms(q).forEach(function (t) { ts.push(t); if (SYN[t]) ts.push(SYN[t]); });
    ts = ts.filter(function (t) { return t.length > 1; }).map(reEsc);
    if (!ts.length) return esc(raw);
    return raw.split(new RegExp('(' + ts.join('|') + ')', 'gi')).map(function (part, i) { return i % 2 ? '<mark>' + esc(part) + '</mark>' : esc(part); }).join('');
  }
  // preview/admin bars can be injected around a layout-none response: keep only the JSON array
  function parseIndex(text) { return JSON.parse(text.slice(text.indexOf('['), text.lastIndexOf(']') + 1)); }

  var indexPromise = null;
  function loadIndex() {
    if (indexPromise) return indexPromise;
    var inline = typeof document !== 'undefined' && document.getElementById('hc-index');
    indexPromise = inline ? Promise.resolve(parseIndex(inline.textContent))
      : fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'pages/help-index', { credentials: 'same-origin' })
        .then(function (r) { return r.text(); }).then(parseIndex).catch(function () { indexPromise = null; return []; });
    return indexPromise;
  }

  // feedback is analytics: send only with the visitor's analytics consent (UK PECR); no consent API = no event
  function canTrack(shopify) {
    var cp = shopify && shopify.customerPrivacy;
    try { return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()); } catch (err) { return false; }
  }

  window.MsofasHelp = { find: find, mark: mark, parseIndex: parseIndex, loadIndex: loadIndex, canTrack: canTrack };
  if (typeof document === 'undefined') return;

  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15m-6-6 6 6-6 6"/></svg>';
  var reduced = function () { return matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var root = function () { return window.Shopify && Shopify.routes ? Shopify.routes.root : '/'; };
  var allUrl = function (q) { return root() + 'pages/help-all-articles' + (q ? '?q=' + encodeURIComponent(q) : ''); };

  /* ---- panel search suggestions ---- */
  var sgIndex = -1;
  function input() { return document.getElementById('hc-search'); }
  function list() { return document.getElementById('hc-suggest'); }
  function closeSuggest() {
    var l = list(), i = input(); if (!l) return;
    l.hidden = true; l.innerHTML = ''; i.setAttribute('aria-expanded', 'false'); i.removeAttribute('aria-activedescendant'); sgIndex = -1;
  }
  function moveSuggest(d) {
    var opts = list().querySelectorAll('[role=option]'); if (!opts.length) return;
    sgIndex = (sgIndex + d + opts.length) % opts.length;
    opts.forEach(function (o, j) { o.setAttribute('aria-selected', String(j === sgIndex)); });
    input().setAttribute('aria-activedescendant', opts[sgIndex].id);
    opts[sgIndex].scrollIntoView({ block: 'nearest' });
  }
  document.addEventListener('input', function (e) {
    if (e.target.id !== 'hc-search') return;
    var q = e.target.value.trim();
    if (q.length < 2) return closeSuggest();
    loadIndex().then(function (index) {
      if (input().value.trim() !== q) return;
      var l = list(), hits = find(index, q), n = Math.min(hits.length, 5);
      var contact = (document.querySelector('.hc .split-contact') || {}).href || root() + 'pages/help-contact';
      sgIndex = -1;
      l.innerHTML = hits.length
        ? hits.slice(0, 5).map(function (a, j) { return '<li role="option" id="hc-sg-' + j + '" aria-selected="false" data-href="' + esc(a.u) + '"><span>' + mark(a.t, q) + '</span><small>' + esc(a.c) + '</small></li>'; }).join('') +
          '<li role="option" id="hc-sg-' + n + '" aria-selected="false" class="suggest-all" data-href="' + esc(allUrl(q)) + '">See all ' + hits.length + ' ' + (hits.length === 1 ? 'result' : 'results') + ' ' + ARROW + '</li>'
        : '<li class="suggest-empty">No matching articles. Try a shorter word, or <a href="' + esc(contact) + '">ask our team</a>.</li>';
      l.hidden = false; input().setAttribute('aria-expanded', 'true');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.target.id !== 'hc-search' || !list() || list().hidden) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); moveSuggest(1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); moveSuggest(-1); }
    else if (e.key === 'Escape') closeSuggest();
    else if (e.key === 'Enter' && sgIndex >= 0) { e.preventDefault(); location.href = list().querySelectorAll('[role=option]')[sgIndex].dataset.href; }
  });
  document.addEventListener('focusout', function (e) {
    var form = e.target.closest && e.target.closest('.hc .searchform');
    if (form && !(e.relatedTarget && form.contains(e.relatedTarget))) closeSuggest();
  });
  document.addEventListener('mousedown', function (e) {
    var o = e.target.closest('.hc .suggest [role=option]');
    if (o) { e.preventDefault(); location.href = o.dataset.href; }
    else if (!e.target.closest('.hc .searchform')) closeSuggest();
  });
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-hc-search]')) return;
    var q = (new FormData(e.target).get('q') || '').trim();
    if (!q) { e.preventDefault(); location.href = allUrl(''); }
  });

  /* ---- all-articles page: client-side results for ?q= (the full list stays for no-JS) ---- */
  function renderResults() {
    var box = document.querySelector('.hc [data-hc-results]');
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (input() && q) input().value = q;
    if (!box || !q) return;
    loadIndex().then(function (index) {
      var hits = find(index, q), all = document.querySelector('.hc [data-hc-all-list]');
      box.querySelector('[data-hc-results-head]').innerHTML = esc(box.dataset.heading).replace('{q}', '“' + esc(q) + '”').replace('{n}', hits.length);
      box.querySelector('[data-hc-results-list]').innerHTML = hits.map(function (a) {
        return '<a class="article-row" href="' + esc(a.u) + '"><span class="tag">' + esc(a.c) + '</span><h2>' + mark(a.t, q) + '</h2><p>' + mark(a.s, q) + '</p>' + ARROW + '</a>';
      }).join('');
      box.querySelector('[data-hc-empty]').hidden = hits.length > 0;
      box.hidden = false;
      if (all) all.hidden = true;
    });
  }

  /* ---- tabs (landing) ---- */
  function selectTab(t) {
    t.closest('[role=tablist]').querySelectorAll('[role=tab]').forEach(function (b) {
      var on = b === t;
      b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1;
      document.getElementById(b.getAttribute('aria-controls')).hidden = !on;
    });
    t.focus();
  }
  document.addEventListener('click', function (e) { var t = e.target.closest('.hc [role=tab]'); if (t) selectTab(t); });
  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('.hc [role=tab]');
    if (!t || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) < 0) return;
    e.preventDefault();
    var tabs = Array.prototype.slice.call(t.closest('[role=tablist]').querySelectorAll('[role=tab]')), i = tabs.indexOf(t);
    var next = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    selectTab(tabs[next]);
  });

  /* ---- ordering guide: jump bar, step tracking, enlarge dialog ---- */
  function trackSteps() {
    var heads = Array.prototype.slice.call(document.querySelectorAll('.hc .tutorial-step h2[id]'));
    if (!heads.length || !('IntersectionObserver' in window)) return;
    var label = document.querySelector('.hc .tutorial-progress');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var i = heads.indexOf(en.target);
        document.querySelectorAll('.hc [data-guide-jump]').forEach(function (b, j) {
          b.classList.toggle('done', j < i);
          if (j === i) { b.setAttribute('aria-current', 'step'); var bar = b.parentElement; bar.scrollLeft = b.offsetLeft - bar.offsetLeft - bar.clientWidth / 2 + b.offsetWidth / 2; }
          else b.removeAttribute('aria-current');
        });
        if (label) label.textContent = label.dataset.template.replace('{n}', i + 1).replace('{total}', heads.length);
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    heads.forEach(function (h) { io.observe(h); });
  }
  document.addEventListener('click', function (e) {
    var jump = e.target.closest('.hc [data-guide-jump]');
    if (jump) { var t = document.getElementById(jump.dataset.guideJump); if (t) { t.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' }); t.focus({ preventScroll: true }); } }
    var zoom = e.target.closest('.hc [data-guide-image]');
    if (zoom) {
      var src = zoom.querySelector('img'), dialog = document.getElementById('hc-guide-dialog'), img = dialog.querySelector('img');
      img.src = src.dataset.large || src.currentSrc || src.src; img.alt = src.alt;
      var cap = zoom.closest('figure').querySelector('figcaption');
      dialog.querySelector('figcaption').textContent = cap ? cap.textContent : '';
      dialog.showModal(); // native dialog: Escape closes and focus returns to the button
    }
    var d = e.target.closest('#hc-guide-dialog');
    if (d && e.target === d) d.close(); // backdrop click
    if (e.target.closest('.hc [data-print]')) window.print();
  });

  /* ---- measuring checklist ---- */
  document.addEventListener('change', function (e) {
    var box = e.target.closest('.hc [data-hc-checklist]');
    if (!box) return;
    var total = box.querySelectorAll('input[type=checkbox]').length, done = box.querySelectorAll('input:checked').length;
    box.querySelector('.check-status').textContent = (done === total ? box.dataset.doneTemplate : box.dataset.template).replace('{n}', done).replace('{total}', total);
    var p = box.querySelector('progress'); if (p) p.value = done;
  });

  /* ---- "Was this useful?" → Klaviyo, identified visitors only (decision 2026-10-20) ---- */
  function klaviyoIdentity(box) {
    if (box.dataset.email) return { email: box.dataset.email };
    var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!m) return null;
    try {
      var id = JSON.parse(atob(decodeURIComponent(m[1])));
      if (id.$exchange_id) return { _kx: id.$exchange_id };
      if (id.$email) return { email: id.$email };
    } catch (err) { /* unreadable cookie = anonymous */ }
    return null;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.hc [data-feedback]');
    if (!b) return;
    var box = b.closest('[data-hc-feedback]'), yes = b.dataset.feedback === 'yes';
    box.querySelectorAll('[data-feedback]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); x.disabled = true; });
    box.querySelector('[data-hc-feedback-yes]').hidden = !yes;
    box.querySelector('[data-hc-feedback-no]').hidden = yes;
    var who = klaviyoIdentity(box);
    if (!who || !canTrack(window.Shopify)) return;
    fetch('https://a.klaviyo.com/client/events/?company_id=S2t7SE', {
      method: 'POST', keepalive: true,
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-07-15' },
      body: JSON.stringify({ data: { type: 'event', attributes: {
        metric: { data: { type: 'metric', attributes: { name: 'Help Article Feedback' } } },
        profile: { data: { type: 'profile', attributes: who } },
        properties: { article_handle: box.dataset.handle, article_title: box.dataset.title, value: yes ? 'yes' : 'no' }
      } } })
    }).catch(function () {});
  });

  /* ---- back-to-top with reading progress ring ---- */
  var toTop = document.querySelector('.hc [data-hc-top]'), bar = toTop && toTop.querySelector('.to-top-bar');
  function updateToTop() {
    if (!toTop) return;
    var max = document.documentElement.scrollHeight - innerHeight, pct = max > 0 ? Math.min(100, Math.max(0, scrollY / max * 100)) : 0;
    bar.style.strokeDashoffset = String(100 - pct);
    toTop.classList.toggle('is-visible', scrollY > 400);
    toTop.setAttribute('aria-label', 'Back to top (' + Math.round(pct) + '% of page read)');
  }
  if (toTop) {
    addEventListener('scroll', function () { requestAnimationFrame(updateToTop); }, { passive: true });
    addEventListener('resize', updateToTop);
    toTop.addEventListener('click', function () {
      scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' });
      var m = document.querySelector('main');
      if (m) { if (!m.hasAttribute('tabindex')) m.setAttribute('tabindex', '-1'); m.focus({ preventScroll: true }); }
    });
  }

  // the desktop menu button only toggles the category bar, which help pages hide: open the menu drawer instead
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nav-bar-button]');
    if (!b || !document.querySelector('.hc-panel')) return;
    var drawer = document.querySelector('[data-menu-button]');
    if (!drawer) return;
    e.preventDefault(); e.stopImmediatePropagation();
    drawer.click();
  }, true);

  // mobile: topic chips scroll sideways — bring the current one into view without moving the page
  function centreCurrentTopic() {
    var nav = document.querySelector('.hc-panel .split-nav'), cur = nav && nav.querySelector('[aria-current]');
    if (cur && nav.scrollWidth > nav.clientWidth) nav.scrollLeft = cur.offsetLeft - nav.clientWidth / 2 + cur.offsetWidth / 2;
  }

  // contact form: Shopify only refills name/email/phone/message after a server error — keep topic + order number too
  function keepContactChoices() {
    var f = document.getElementById('hc-contact');
    if (!f) return;
    var KEY = 'hc-contact-choices', store;
    try { store = window.sessionStorage; } catch (err) { return; }
    var err = document.querySelector('.hc .hc-form-status--error'), ok = document.querySelector('.hc .hc-form-status--ok');
    try {
      if (ok) store.removeItem(KEY);
      else if (err) {
        var saved = JSON.parse(store.getItem(KEY) || '{}');
        if (saved.topic) f.querySelector('#hc-c-topic').value = saved.topic;
        if (saved.order) f.querySelector('#hc-c-order').value = saved.order;
      }
    } catch (e2) { /* storage blocked: nothing to restore */ }
    f.addEventListener('submit', function () {
      try { store.setItem(KEY, JSON.stringify({ topic: f.querySelector('#hc-c-topic').value, order: f.querySelector('#hc-c-order').value })); } catch (e3) { /* ignore */ }
    });
  }

  function init() { renderResults(); trackSteps(); updateToTop(); centreCurrentTopic(); keepContactChoices(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
